import QueryString from 'qs';
import { Params } from '@angular/router';

export const queryParamsStringify = (queryParams: Params): string => {
  return QueryString.stringify(queryParams);
};
